import { CE } from './ce';

export class SE extends CE {}
